import { useEffect } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { authService } from 'modules/auth/services/authService';
import { API_BASE_URL } from 'config';

/**
 * Mantém uma conexão SignalR ao `/hubs/presenca` enquanto o usuário está logado.
 * Estar conectado já é a presença — o hub registra connect/disconnect no servidor
 * (alimenta o painel Admin "usuários online"). Sem grupos, sem eventos.
 * Montar nos layouts autenticados (interno e portal).
 */
export function usePresenca(): void {
  useEffect(() => {
    if (!authService.getToken()) return;

    const conn = new HubConnectionBuilder()
      .withUrl(`${API_BASE_URL}/hubs/presenca`, { accessTokenFactory: () => authService.getToken() ?? '' })
      .withAutomaticReconnect()
      .build();

    conn.start().catch(() => { /* offline / sem permissão: presença apenas não registra */ });

    return () => {
      conn.stop().catch(() => {});
    };
  }, []);
}
